import $ from 'jquery';
import { isTouch } from './utils';

const $html = $('html');

function init (){
  if (isTouch) {
    $html.addClass('has-touch');
  }
}

export default {
  init
}
